import {cssTheme} from '../theme'
import {css} from '../theme/css'

export const classes = {
  avatar: css`
    color: black;
  `,
  image: css`
    vertical-align: middle;
    border-radius: 50%;
    overflow: hidden;
    position: relative;
    // https://gist.github.com/ayamflow/b602ab436ac9f05660d9c15190f4fd7b
    // noinspection CssInvalidPropertyValue
    -webkit-mask-image: -webkit-radial-gradient(white, black);
  `,
  camera: css`
    position: absolute;
    inset-inline-start: 0;
    inset-block-start: 0;
    inline-size: 100%;
    block-size: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    text-align: center;
    line-height: 49px;
    transform: translateY(60%);
    transition: transform 0.2s ease;
    pointer-events: auto;
    color: white;
    z-index: 0;

    & svg {
      transform-origin: 50% 50%;
      transform: translateY(-90%);
      transition: transform 0.2s ease;
      margin: 0 auto;
    }

    &:hover {
      transform: translateY(0);
    }

    &:hover svg {
      transform: translateY(0) scale(150%);
    }
  `,
}

export const listClasses = {
  listItem: css`
    white-space: nowrap;
    inline-size: 100%;
    user-select: none;
    padding: ${cssTheme.spacingUnits.s};

    &:before {
      /* Перезаписываем стиль GWC, в данном случае дивайдеры только мешают */
      border-top: none !important;
    }
  `,
}
